import { Enums } from '@configur-tech/upit-core-types';
import React, { FC } from 'react';
import ProjectDatasetsStage from '../../components/ProjectItem/ProjectItemDatasetsStage/ProjectItemDatasetsStage';
import PageFeatureHeader from '../../components/PageFeatureHeader/PageFeatureHeader';
import Page from '../../main/Page';
import {
  getProjectStageContent,
  getProjectStageTitle,
} from '../../util/project-stage-content/ProjectStageContent';

const ProjectItemDatasets: FC = () => {
  const activeStage = Enums.ProjectStage.DATASETS;
  const stageTitle = getProjectStageTitle(activeStage);
  const stageContent = getProjectStageContent(activeStage);

  return (
    <>
      <PageFeatureHeader
        pageHeader={stageTitle}
        image={stageContent.image}
        title={stageContent.title}
      />

      <Page>
        <ProjectDatasetsStage />
      </Page>
    </>
  );
};

export default ProjectItemDatasets;
